import { render, staticRenderFns } from "./CRUDTableStaff.vue?vue&type=template&id=3fbe4fad&scoped=true"
import script from "./CRUDTableStaff.vue?vue&type=script&lang=js"
export * from "./CRUDTableStaff.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableStaff.vue?vue&type=style&index=0&id=3fbe4fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbe4fad",
  null
  
)

export default component.exports